import store from "@/store.js";

import CreateCourses from "@/components/CreateCourses";
import ImportXLS from "@/components/ImportXLS";

export default {
  id: 1,
  adminOnly: false,
  type: "locations",
  title: "Localizaciones",
  deleteEntriesAllowed: true,
  actions: {
    get: "getLocations",
    post: "postLocation",
    patch: "patchLocation",
    delete: "deleteLocation",
  },
  headers: [
    {
      title: "ID Localización",
      field: {
        name: "ID_Location",
        type: "text",
        editable: true,
      },
    },
    {
      title: "Descripción",
      field: {
        name: "descripcion",
        type: "text",
        editable: true,
      },
    },
  ],
  options: [
    {
      title: "Crear todos los cursos",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: CreateCourses,
          title: `Crear cursos generales a ${entry.ID_Location}`,
          props: {
            location: entry.ID_Location,
          },
        });
      },
    },
    {
      title: "Descargar plantilla XLS Profesores",
      type: "anchor",
      href: "server/templates/profes.xls",
    },
    {
      title: "Importar profesores",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: ImportXLS,
          title: `Importar profesores a ${entry.ID_Location}`,
          props: {
            entry,
            import: "teachers",
          },
        });
      },
    },
    {
      title: "Descargar plantilla XLS Asignaturas",
      type: "anchor",
      href: "server/templates/asignaturas_location.xls",
    },
    {
      title: "Importar asignaturas",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: ImportXLS,
          title: `Importar asignaturas a ${entry.ID_Location}`,
          props: {
            entry,
            import: "disciplines",
          },
        });
      },
    },
    {
      title: "Descargar plantilla XLS Alumnos",
      type: "anchor",
      href: "server/templates/alumnos_locations.xls",
    },
    {
      title: "Importar alumnos",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: ImportXLS,
          title: `Importar alumnos a ${entry.ID_Location}`,
          props: {
            entry,
            import: "students",
          },
        });
      },
    },
  ],
  filters: [],
};
